import { InvoiceStatus } from '../../../back-end/common/invoice'

export type InvoiceState = 'draft' | 'awaiting-approval' | 'approved' | 'awaiting-payment' | 'paid' | 'unknown'

export const invoiceState = (status: InvoiceStatus, sentToContact: boolean): InvoiceState => {
	if (status === 'DRAFT') {
		return 'draft'
	} else if (status === 'SUBMITTED') {
		return 'awaiting-approval'
	} else if (status === 'AUTHORISED' && !sentToContact) {
		return 'approved'
	} else if (status === 'AUTHORISED' && sentToContact) {
		return 'awaiting-payment'
	} else if (status === 'PAID') {
		return 'paid'
	}
	return 'unknown'
}
